if (!customElements.get('simple-pagination')) {
    class SimplePagination extends HTMLElement {
      constructor() {
        super();
        this.itemsPerPage = {
          mobile: parseInt(this.dataset.maxMobile),
          desktop: parseInt(this.dataset.maxDesktop)
        };
        this.showMoreStep = {
          mobile: parseInt(this.dataset.stepMobile),
          desktop: parseInt(this.dataset.stepDesktop)
        };
        this.currentItemsShown = 0;
        this.allItems = [];
        this.showMoreButton = null;
        this.listContainer = null;
        this.lastBreakpoint = null;
  
        this.init();
      }
  
      init() {
        this.listContainer = this.querySelector('[data-list]');
        this.showMoreButton = this.querySelector('[data-show-more]');
  
        if (!this.listContainer) return;
  
        // Get all items
        this.allItems = Array.from(this.listContainer.children);
  
        // Set up show more button
        if (this.showMoreButton) {
          this.showMoreButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.showMore();
          });
        }
  
        // Initial display
        this.currentItemsShown = this.getItemsPerPage();
        this.lastBreakpoint = this.getCurrentBreakpoint();
        this.updateVisibility();
  
        // Handle resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.handleResize();
          }, 250);
        });
      }
  
      getCurrentBreakpoint() {
        return window.innerWidth >= 990 ? 'desktop' : 'mobile';
      }
  
      getItemsPerPage() {
        return window.innerWidth >= 990 ? this.itemsPerPage.desktop : this.itemsPerPage.mobile;
      }
  
      getShowMoreStep() {
        return window.innerWidth >= 990 ? this.showMoreStep.desktop : this.showMoreStep.mobile;
      }
  
      handleResize() {
        const currentBreakpoint = this.getCurrentBreakpoint();
        
        // Only reset if breakpoint changed
        if (currentBreakpoint !== this.lastBreakpoint) {
          this.currentItemsShown = this.getItemsPerPage();
          this.lastBreakpoint = currentBreakpoint;
        }
        
        this.updateVisibility();
      }
  
      updateVisibility() {
        // Show/hide items
        this.allItems.forEach((item, index) => {
          if (index < this.currentItemsShown) {
            item.setAttribute('data-show', '');
          } else {
            item.removeAttribute('data-show');
          }
        });
  
        // Show/hide button
        if (this.showMoreButton) {
          if (this.currentItemsShown >= this.allItems.length) {
            this.showMoreButton.removeAttribute('data-show');
          } else {
            this.showMoreButton.setAttribute('data-show', '');
          }
        }
      }
  
      showMore() {
        const step = this.getShowMoreStep();
        this.currentItemsShown += step;
  
        // Don't exceed total items
        if (this.currentItemsShown > this.allItems.length) {
          this.currentItemsShown = this.allItems.length;
        }
  
        this.updateVisibility();
      }
    }
  
    customElements.define('simple-pagination', SimplePagination);
  }
  